import Benefit from './Benefit';

export default Benefit;